import React from 'react';
import { TVoteResult } from '../../../../store/interactive/types';
import { ChartView } from '../../../Chart';

interface TestProps {
  voteResult: TVoteResult;
}

export const VoteResult: React.FC<TestProps> = React.memo(({ voteResult }) => {
  const labels = voteResult.params.map((item) => {
    return String(item.title);
  });
  const dataOption = voteResult.params.map((item) => {
    return String(item.value);
  });
  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Віддано голосів, %',
        data: [...dataOption],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };
  const scales = {};
  return (
    <div style={{ padding: '20px 50px' }}>
      <h1 style={{ textAlign: 'center' }}>Результати голосування</h1>
      <h2 style={{ textAlign: 'center' }}>{`Питання. ${voteResult.title}`}</h2>
      <ChartView type={'doughnut'} scales={scales} legend={true} data={data} />
    </div>
  );
});
